/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { featureFlagSchema } from '../schemas';

export const upsertFeatureFlagResponseSchema = createApiResponseSchema(
  featureFlagSchema,
) as z.ZodSchema<IAPI<z.infer<typeof featureFlagSchema>>>;

export type IUpsertFeatureFlagResponse = IAPI<z.infer<typeof featureFlagSchema>>;
